export const GET_REPORT_DATA = 'GET_REPORT_DATA'
export const GET_DADOS_CHAMADA = 'GET_DADOS_CHAMADA'
export const GET_CONFERENCIAS = 'GET_CONFERENCIAS'
